<template>
  <div class="detailBox">
    <div class="detailHead">
      <div @click="handlePrev" class="detailHeadLeft">上一页</div>
      <div @click="$router.go(-1)" class="detailHeadLef">返回网站</div>
      <div class="detailHeadMiddle">
        <div class="detailHeadTotal">当前页面{{total}}张  第{{query.page}}页</div>
      </div>
      <div @click="handleNext" class="detailHeadRight">下一页</div>
    </div>
    <div style="height: 44px"></div>
    <div class="detailContent">
      <div v-if="total == 0" class="noData">
        客官莫急，还在助力中~
      </div>

      <div v-if="(total !== 0) && listData.length == 0" class="empty">
        没有更多数据了~
      </div>
      
      <el-row :gutter="10">
        <el-col 
          :key="index" 
          v-for="(item, index) in listData" 
          :xs="12" 
          :md="6"
        >
          <div class="detailItem">
            <img
              class="detailItemImg"
              :src="(item.USERIMG == 'null' || item.USERIMG == 'NO DATA' || !item.USERIMG) ? t : item.USERIMG"
              alt=""
              @click="showPreview((item.USERIMG == 'null' || item.USERIMG == 'NO DATA' || !item.USERIMG) ? t : item.USERIMG)"
            />
            <img
              class="detailItemImg detailItemImg2"
              :src="item.IMG"
              alt=""
              @click="showPreview(item.IMG)"
            />
            <div class="detailItemBottom">
              <div class="detailItemOrder">第{{index + query.page*10 + 1 - 10}}次</div>
              <div class="detailItemOrder">["{{item.name}}"]</div>
              <div class="detailItemOrder">{{item.Time}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 44px"></div>
    
    <!-- 图片预览弹窗 -->
    <div v-if="previewVisible" class="image-preview" @click.self="closePreview">
      <div class="preview-content">
        <img :src="previewImage" class="preview-image" />
        <div class="preview-close" @click="closePreview">×</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
import t from '../../assets/template.png';

export default {
  data() {
    return {
      total: 0,
      t,
      query: {
        act: "pic",
        id: "sz9zcaANu6OGW5CuklQss3mxbouXqe",
        page: 1,
        m: "daochu",
      },
      listData: [],
      previewVisible: false, // 预览弹窗显示状态
      previewImage: ""      // 当前预览的图片URL
    };
  },
  mounted() {
    this.query.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    handlePrev() {
      if(this.query.page <= 1) return;
      this.query.page -= 1;
      this.getData();
    },
    handleNext() {
      this.query.page += 1;
      this.getData();
    },
    handleAll() {
      this.query.page = 0;
      this.getData();
    },
    getData() {
      this.loading = Loading.service({ fullscreen: true, text: '数据加载中...' });
      axios
        .get("https://api2.xn--nfv429h.net/api.php", { params: this.query })
        .then((res) => {
          this.listData = res.data.data;
          this.total = res.data.total;
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    
    // 显示图片预览
    showPreview(imgUrl) {
      this.previewImage = imgUrl;
      this.previewVisible = true;
      // 禁止背景滚动
      document.body.style.overflow = 'hidden';
    },
    
    // 关闭预览
    closePreview() {
      this.previewVisible = false;
      // 恢复背景滚动
      document.body.style.overflow = '';
    }
  },
  destroyed() {}
};
</script>

<style scoped>
@import url("./detail.css");

/* 图片预览样式 */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-image {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  margin: 0 auto;
}

.preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  color: white;
  font-size: 40px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  line-height: 36px;
  text-align: center;
}

/* 确保所有图片都可点击 */
.detailItemImg {
  cursor: pointer;
}
</style>
